import getInitialState from './state';

const mutations = {
  setStatus(state, value) {
    const states = Object.keys(state.STATUS);
    if (states.includes(value)) {
      states.forEach((key) => {
        state.STATUS[key] = (key === value);
      });
    }
  },
  setData(state, value) {
    state.data = {
      ...state.data,
      ...value,
    };
  },
  setError(state, error) {
    state.error = error;
  },
  doneStep(state, step) {
    state.done[step] = true;
  },
  enableStep(state, step) {
    state.activeSteps[step] = true;
  },
  disableStep(state, step) {
    state.activeSteps[step] = false;
  },
  unDoneStep(state, step) {
    Object.keys(state.done).forEach((stepItems) => {
      if (stepItems >= step) {
        state.done[step] = false;
      }
    });
  },
  updateStep(state, step) {
    state.currentStep = step;
  },
  resetUser(state) {
    return Object.assign(state, getInitialState());
  },
  // Info
  legalDocuments(state, documents) {
    state.info.legalDocuments = documents;
  },
  country(state, country) {
    state.info.country = country;
  },
  // Setters
  email(state, email) {
    state.data.email = email;
  },
  password(state, password) {
    state.data.password = password;
  },
  title(state, title) {
    state.data.title = title;
  },
  firstName(state, firstName) {
    state.data.first_name = firstName;
  },
  lastName(state, lastName) {
    state.data.last_name = lastName;
  },
  birthDate(state, birthDate) {
    state.data.birthdate = birthDate;
  },
  address(state, address) {
    state.data.address = address;
  },
  addressDetails(state, addressDetails) {
    state.data.address_details = addressDetails;
  },
  phone(state, phone) {
    state.data.phone = phone;
  },
  legalDocumentsAccepted(state, legalDocumentsAccepted) {
    state.data.legal_document_uuids = legalDocumentsAccepted;
  },
  receiveNews(state, receiveNews) {
    state.data.allow_direct_marketing = receiveNews;
  },
  isEmployee(state, isEmployee) {
    state.b2b.isEmployee = isEmployee;
  },
  isEmailFromCompany(state, isEmailFromCompany) {
    state.b2b.email_from_company = isEmailFromCompany;
  },
  setPromoCode(state, code) {
    state.data.promoCode = code;
  },
  setInvitationData(state, invitation) {
    state.b2b.invitation = invitation;
  },
  setValidInvite(state, validInvite) {
    state.b2b.invitation.valid_invite = validInvite;
  },
  setInvitationCompany(state, company) {
    state.b2b.invitation.company = company;
  },
  setCompanyOperatorUuid(state, uuid) {
    state.b2b.invitation.company.cs_operator_uuid = uuid;
  },
};
export default mutations;
